import { render } from "./AddEducationalUnit.vue?vue&type=template&id=19afaed7&scoped=true"
import script from "./AddEducationalUnit.vue?vue&type=script&lang=js"
export * from "./AddEducationalUnit.vue?vue&type=script&lang=js"

import "./AddEducationalUnit.vue?vue&type=style&index=0&id=19afaed7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19afaed7"]])

export default __exports__